
import React, { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useDashboard } from '@/hooks/useDashboard';
import { useLocation } from 'react-router-dom';
import AuthForm from '@/components/AuthForm';
import Logo from '@/components/navbar/Logo';

const Auth = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { user } = useAuth();
  
  const location = useLocation();
  const { trackReferral } = useDashboard();
  
  useEffect(() => {
    // Check if user was referred by someone
    const params = new URLSearchParams(location.search);
    const referrerId = params.get('ref');
    
    if (referrerId && user) {
      // Process the referral after successful signup
      trackReferral(referrerId);
    }
  }, [user, location.search, trackReferral]);

  useEffect(() => {
    if (user) {
      navigate('/profile');
    } else {
      setLoading(false);
    }
  }, [user, navigate]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex flex-col min-h-screen">
      <header className="bg-background border-b">
        <div className="container mx-auto px-4 h-16 flex items-center justify-between">
          <Logo />
          <div></div>
        </div>
      </header>
      <main className="container mx-auto px-4 py-8 flex-grow flex items-center justify-center">
        <div className="max-w-md w-full">
          <AuthForm />
        </div>
      </main>
      <footer className="bg-background border-t">
        <div className="container mx-auto px-4 py-4 text-center text-muted-foreground">
          <p>&copy; {new Date().getFullYear()} TeenVisor. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default Auth;
